/** One `Non-Covered` line of a care-setting tab — `details.<tab>.serviceDetails.nonCovered[i]` (CLE-2933). */
export interface INonCoveredRow {
  messages?: string[] | null;
  networkIndicator?: string | null;
}

/** Network indicators whose Non-Covered lines explain the in-network "NON COVERED" status. */
const IN_NETWORK_INDICATORS = ["Yes", "Both"];

/**
 * CLE-2933 — the payer's qualifier text to print under a tab's "NON COVERED" status, e.g.
 * `FOR PREVENTATIVE CARE VISITS`, so staff can see the exclusion is narrower than the whole
 * setting.
 *
 * Only in-network lines count, because the status itself comes from `ServiceCoveredInNet`: an
 * out-of-network ("No") line's text would explain something the status does not say. A line with
 * no indicator reads as "Both" (Ani's CLE-2756 ruling). Messages are trimmed, empties dropped and
 * repeats removed, in document order. A response stored before the field existed has no rows, so
 * its footer renders exactly as before.
 */
export const nonCoveredQualifiers = (
  rows: INonCoveredRow[] | null | undefined
): string[] => {
  const qualifiers: string[] = [];
  (rows || [])
    .filter(
      (row) =>
        row.networkIndicator === null ||
        row.networkIndicator === undefined ||
        IN_NETWORK_INDICATORS.includes(row.networkIndicator)
    )
    .forEach((row) => {
      (row.messages || []).forEach((message) => {
        const text = (message || "").trim();
        if (text && !qualifiers.includes(text)) qualifiers.push(text);
      });
    });
  return qualifiers;
};
